import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import {
  Body1,
  BottomDocked,
  Button,
  Col,
  colors,
  Content,
  H3,
  Message,
  Page,
  Row,
  Spacer,
} from '../components'
import { Config } from '../const'
import { loadProperty } from '../helper/LocalStorage'
import { InstallPrompt } from './InstallPrompt'

const Headline = styled(H3)`
  margin-top: 0;
`

let appIsInstalled = loadProperty('appInstalled') || false

if (
  window.matchMedia('(display-mode: standalone)').matches ||
  (window.navigator as any).standalone
) {
  // PWA is installed
  console.log('PWA is already installed')
  appIsInstalled = true
} else {
  // PWA is not installed
  console.log('PWA is not installed')
}

const nextPage = Config.REACT_APP_IS_FUSION ? '/no-photos' : '/timetable'

const Start = () => {
  const navigate = useNavigate()

  useEffect(() => {
    if (appIsInstalled) {
      navigate(nextPage)
    }
  }, [navigate])

  return (
    <Page>
      <Content color={colors.textAlt}>
        <Col gap={6} flexDirection="column">
          <Headline>
            <Message id="WELCOME_HEADLINE" />
          </Headline>

          <Body1>
            <Message id="WELCOME_MESSAGE" renderRawHtml />
          </Body1>

          <InstallPrompt appIsInstalled={appIsInstalled} />

          <Body1 $mt={6}>
            <Message id="WELCOME_MESSAGE_INSTALL_END" renderRawHtml />
          </Body1>
        </Col>

        {Config.REACT_APP_SHOW_NOT_REALEASED && (
          <>
            <Spacer size={4} />
            <H3>
              <Message id="WELCOME_MESSAGE_NOT_RELEASED" />
            </H3>
          </>
        )}
      </Content>
      <BottomDocked>
        <Row>
          <Button
            disabled={Config.REACT_APP_SHOW_NOT_REALEASED}
            onClick={() => {
              navigate(nextPage)
            }}
          >
            <Message id="NEXT" />
          </Button>
          <Spacer size={2} />
        </Row>
      </BottomDocked>
    </Page>
  )
}

export default Start
